import React from 'react';
import { Nav } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';

const Sidebar = ({ isOpen, onClose }) => {
  const menuItems = [
    { path: '/', label: '챗봇', icon: 'fa-comments' },
    { path: '/dashboard', label: '대시보드', icon: 'fa-chart-pie' },
    { path: '/charts', label: '차트', icon: 'fa-chart-bar' },
    { path: '/traders', label: '트레이더', icon: 'fa-users' }
  ];

  return (
    <div className={`sidebar ${isOpen ? 'mobile-open' : ''}`}>
      <Nav className="flex-column">
        {menuItems.map(item => (
          <Nav.Link 
            key={item.path}
            as={NavLink}
            to={item.path}
            className="sidebar-item"
            onClick={onClose}
          >
            <i className={`fas ${item.icon}`}></i>
            <span>{item.label}</span>
          </Nav.Link>
        ))}
      </Nav>
      
      <div className="sidebar-logo">
        <img src="/logo-sq.png" alt="KiNFRi Logo" />
      </div>
    </div>
  );
};

export default Sidebar;
